import { Close } from '@mui/icons-material';
import { RootState } from '../../../redux/store';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { Box, Button, Checkbox, ClickAwayListener, Divider, FormControlLabel, IconButton, Paper, Popper, Typography } from '@mui/material';

interface NavbarSelectionProps {
    openPopup: HTMLElement | null;
    closePopup: () => void;
    menuItems: { value: string; label: string }[];
    selectedItems: string[];
    submitHandler: (value: string[]) => void;
}

const NavbarSelection = ({ openPopup, closePopup, menuItems, selectedItems, submitHandler }: NavbarSelectionProps) => {
    const [selectedBars, setSelectedBars] = useState<string[]>(selectedItems);
    const { selectedClient } = useSelector((state: RootState) => state.client);

    const checkboxHandler = (value: string) => {
        setSelectedBars((prev) => {
            // Prevent unchecking if only 3 are left
            if (prev.includes(value) && prev.length === 3) {
                return prev;
            }
            return prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value];
        });
    };

    const applyHandler = () => {
        submitHandler(selectedBars);
        closePopup();
    };

    return (
        <Popper open={Boolean(openPopup)} anchorEl={openPopup} placement="bottom-start">
            <ClickAwayListener onClickAway={closePopup}>
                <Paper sx={{ p: 2, width: 300, boxShadow: 3 }}>
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                        <Typography variant="body1" fontWeight="bold" color="textSecondary">Personalize your navigation bar</Typography>
                        <IconButton onClick={closePopup}>
                            <Close />
                        </IconButton>
                    </Box>
                    <Divider />
                    <Typography variant="body1" my={1} color="textDisabled">Check to add items to your nav bar, uncheck to remove</Typography>
                    <Box>
                        {menuItems.map((item) => {
                            if (selectedClient?.company_type === 'project' && item.label === 'Billing') {
                                return null;
                            }
                            return <Box key={item.value}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={selectedBars?.includes(item.value)}
                                            onChange={() => checkboxHandler(item.value)}
                                        />
                                    }
                                    label={item.label}
                                />
                            </Box>;
                        })}
                    </Box>
                    <Box display="flex" gap={2} mt={2}>
                        <Button variant="contained" size="medium" fullWidth onClick={applyHandler}>Apply</Button>
                        <Button variant="outlined" size="medium" fullWidth onClick={closePopup}>Cancel</Button>
                    </Box>
                </Paper>
            </ClickAwayListener>
        </Popper>
    );
};

export default NavbarSelection;